import React, { useContext, useState, useEffect } from 'react'
import CustomDialog from '../../custom/components/organisms/Dialog'
import Button from '@material-ui/core/Button'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import UserContext from '../../product/context/user/userContext'
import { mapData } from '../../product/common/components'

export default function PhoneValidation(props) {
    const phoneVerify = props.phoneVerify
    const changePhoneVerify = props.changePhoneVerify
    const formik = props.formik
    const setPhoneVerify = props.setPhoneVerify
    const [disable, setDisable] = useState(false)

    const userContext = useContext(UserContext)

    const {
        sendPhoneVerifyCode,
        verifyPhoneVerifyCode,
        responseStatus: responseStatusUser,
    } = userContext

    const sendVerifyCode = () => {
        sendPhoneVerifyCode({ phone: formik.values.phone })
    }

    const verifyPhoneCode = () => {
        verifyPhoneVerifyCode({
            phone: formik.values.phone,
            verify_code: formik.values.verify_code,
        })
    }

    const verifyPhone = [
        {
            label: 'Verification Code',
            placeholder: 'Enter Verification Code',
            class: 'col-12',
            type: 'number',
            name: 'verify_code',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.from === 'sendPhoneVerifyCode' &&
                responseStatusUser.status === 'success'
            ) {
                formik.values.phone_verifysent = 1
            }
            if (
                responseStatusUser.from === 'verifyPhoneVerifyCode' &&
                responseStatusUser.status === 'success'
            ) {
                formik.values.phone_verified = 1
                formik.values.verified_phonenum = formik.values.phone
                setPhoneVerify(false)
            }
        }
        setDisable(false)
    }, [responseStatusUser])

    return (
        <CustomDialog
            className="verifyPhone"
            title={'Verify Phone'}
            open={phoneVerify}
            // function={changePhoneVerify}
        >
            {'Verify Phone Number'} : {formik.values.phone}
            <br />
            {formik.values.phone_verifysent === 1 && (
                <>
                    <br />
                    <div className="row phVerInp">{Object.values(mapData(verifyPhone))}</div>
                    <span className="phVer">* {'Your Code Will Expire in 5 Minutes'}</span>
                    <br />
                    <br />
                    <PrimaryButton onClick={verifyPhoneCode} label={'Verify Code'} />
                </>
            )}
            <div className="actionWrapper secondaryActions">
                <Button onClick={() => changePhoneVerify()}>{'Cancel'}</Button>
                {formik.values.phone_verifysent === 1 ? (
                    <Button
                        disabled={disable}
                        className="resendSms"
                        onClick={() => {
                            setDisable(true)
                            sendVerifyCode()
                        }}
                    >
                        {'Resend SMS'}
                    </Button>
                ) : (
                    <PrimaryButton label={'Send SMS'} onClick={() => sendVerifyCode()} />
                )}
            </div>
        </CustomDialog>
    )
}
